import React from "react";
import { Message, MessageSizeProp } from "semantic-ui-react";
import { ILimaIPackBox } from "../../../lib/interfaces/ConveyorBox/IConveyorBox";

import styles from "./OrderStatusBlock.module.css";

type Props = {
  iPackBoxID?: ILimaIPackBox["id"];
  isOrderCompleted?: boolean;
  isOrderChecked?: boolean;
  isPickActionTaken?: boolean;
  isItemsVerified?: boolean;
  size?: MessageSizeProp;
  text?: string;
};

const OrderStatusBlock = ({
  iPackBoxID,
  isOrderCompleted,
  isOrderChecked,
  isPickActionTaken,
  isItemsVerified,
  size = "big",
  text,
}: Props) => {
  // if ((iPackBoxID > -1 && !isOrderCompleted) || isOrderChecked) {
  //   return (
  //     <Message
  //       icon="check"
  //       positive
  //       size="big"
  //       header="ORDER OK"
  //       content="Kontrollera att varorna ligger rätt"
  //     />
  //   );
  // } else if (iPackBoxID > -1 && isOrderCompleted) {
  //   return <Message icon="magnify" color="blue" size="big" header="Manuell kontroll" />;
  // }
  // return <div>OrderStatusBlock</div>;
  if (text)
    return (
      <Message
        icon="check"
        positive
        size={size}
        header="ERROR:"
        content={text}
        className={styles["message--action"]}
      />
    );
  if (!isPickActionTaken && !isItemsVerified)
    return (
      <Message
        icon="slack hash"
        color="blue"
        positive
        size={size}
        header="VERIFIERA PLOCK"
        content="Vänligen skanna alla artiklar"
      />
    );
  if (isPickActionTaken)
    return (
      <Message
        icon="check"
        positive
        size={size}
        header="ÅTGÄRD VALD"
        content="Vänligen placera lådan på bandet"
        className={styles["message--action"]}
      />
    );
  return (
    <Message
      icon="check"
      positive
      size={size}
      header="ORDER OK"
      content="Kontrollera att varorna ligger rätt"
    />
  );
};

export default OrderStatusBlock;
